import 'd3';


export default function() {
	return {
		scope: {
			data: '<',
		},
		link: link,
	};

	function link(scope, element, attrs, ctrls) {
		var count = scope.data[0];
		var hist = scope.data[1];

		var color = 'steelblue';

		// Generate a 1000 data points using normal distribution with mean=20, deviation=5
		var values = d3.range(1000).map(d3.random.normal(20, 5));

		// A formatter for counts.
		var formatCount = d3.format(',.0f');

		var margin = {top: 20, right: 30, bottom: 30, left: 30},
			width = 500 - margin.left - margin.right,
			height = 220 - margin.top - margin.bottom;

		var max = 24;
		var min = 0;
		var x = d3.scale.linear()
			.domain([0, max])
			.range([0, width]);

		var yMax = d3.max(hist);
		var yMin = d3.min(hist);

		var colorScale = d3.scale.linear()
			.domain([yMin, yMax])
			.range([d3.rgb(color).brighter(), d3.rgb(color).darker()]);

		var y = d3.scale.linear()
			.domain([0, yMax])
			.range([height, 0]);

		var svg = d3.select(element[0])
			.attr('viewBox', '0 0 500 220')
		  .attr('preserveAspectRatio', 'xMinYMin meet')
			.attr('width', '100%')
			.append('g')
			.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

		var valueline = d3.svg.line()
			.x((d, i) => x(i+0.5))
			.y(d => y(d));

		svg.append('path').attr('class', 'line').attr('d', valueline(hist));

		var yAxis = d3.svg.axis()
			.scale(y)
			.ticks(yMax > 1 ? 2 : 1)
			.tickSize(-width)
			.orient('left');

		var xAxis = d3.svg.axis()
			.scale(x)
			.tickFormat(function(d, i) {
				if (d == 0) {
					return '12am'
				} else if (d < 12) {
					return d + 'am';
				} else if (d == 12) {
					return '12pm';
				} else if (d < 24) {
					return (d-12) + 'pm';
				} else if (d == 24) {
					return '12am';
				}
			})
			.orient('bottom');

		svg.append('g')
			.attr('class', 'x axis')
			.attr('transform', 'translate(0,' + height + ')')
			.call(xAxis);

		svg.append('g')
			.attr('class', 'y axis')
			// .attr('transform', 'translate(0,' + width + ')')
			.call(yAxis);

		var node = svg.selectAll('g')
			.data(hist)
			.enter()
			.append('g');

		var dot = node.selectAll('dot')
			.append('circle')
			.attr('r', 0)
			.attr('cx', (d, i) => x(i+0.5))
			.attr('cy', d => y(d));
	}
}
